module.exports = __webpack_public_path__ + "static/media/telephone.04e70784.svg";